import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#f6ab3f",
      d: "M21 10.8c-.1-.4-.4-.7-.8-.8l-5.4-.9L13 3.7c-.2-.4-.6-.7-1-.7s-.8.3-.9.7L9.2 9.1l-5.4.9c-.4.1-.7.4-.8.8s.1.8.5 1l4.3 2.6-1.7 5.2c-.1.4 0 .9.4 1.1.1.2.3.3.5.3s.4-.1.6-.2l4.4-3.5 4.4 3.5c.2.1.4.2.6.2s.4-.1.6-.2c.4-.3.5-.7.4-1.1l-1.7-5.2 4.3-2.6c.3-.3.5-.7.4-1.1"
    }, null, -1)
  ]))]))
}
export default { render: render }